module.exports = __webpack_public_path__ + "apple-2AZ.png";